import { useParams } from 'react-router';

import { RouterEntitiesId } from '@clearverify/constants';

export const useUserEmailChangeRequestParamId = () => {
  const { emailChangeRequestId } = useParams<{ [RouterEntitiesId.emailChangeRequest]: string }>();
  return emailChangeRequestId;
};
